import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbHomeQuestion } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { pickupReasons } from "@/constants/pickReasons";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";

import { HotelClinicListItem } from "../../types";

function ReasonCell({ row }: { row: HotelClinicListItem }) {
    const status = pickupReasons.find((item) => item.value === row.reason);

    return (
        <div className="flex items-center py-1 h-full">
            {status && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={
                        <div className=" text-sm  !p-0 flex flex-col   gap-1 ">
                            <div
                                className="flex items-center gap-1 p-2   "
                                style={{
                                    color: (row.cancelled && softColors.red.text) || status.text,
                                    backgroundColor: (row.cancelled && softColors.red.bg) || status.bg,
                                }}
                            >
                                {createElement(status.component(), {
                                    fontSize: 14,
                                    color: (row.cancelled && softColors.red.text) || status.text,
                                })}
                                {status.tooltip.title}
                            </div>
                            <span className=" p-2 pl-3">{status.tooltip.description}</span>
                        </div>
                    }
                >
                    <Chip
                        sx={{
                            color: (row.cancelled && softColors.red.text) || status.text,
                            backgroundColor: (row.cancelled && softColors.red.bg) || status.bg,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: (row.cancelled && softColors.red.text) || status.text,
                        })}
                        label={status.label}
                    />
                </NoMaxWidthTooltip>
            )}
        </div>
    );
}

export const HotelPickUpReasonColumn = ({ t }: { t: TFunction }): GridColDef<HotelClinicListItem> => {
    return {
        field: "pickUpReason",
        headerName: t("pickUpReason"),
        minWidth: 180,
        flex: 0.5,
        filterable: false,
        valueGetter: (_val, row) => row.reason,
        renderHeader: (params) => <TableHeader Component={TbHomeQuestion} title={params.colDef.headerName!} />,
        renderCell: ({ row }) => <ReasonCell row={row} />,
    };
};
export default HotelPickUpReasonColumn;
